import { db } from './firebase';
import {collection, getDocs, updateDoc, doc} from 'firebase/firestore';

const setReviewDefaultLanguage = async () => {
    try {

        const querySnapshot = await getDocs(collection(db, 'reviews'));

        const updates = querySnapshot.docs.map(async (document) => {
            const data = document.data();

            if (!data.hasOwnProperty('language')) {
                const docRef = doc(db, 'reviews', document.id);

                await updateDoc(docRef, {
                    language: 'ro',
                });
                console.log(`Document ${document.id} updated with language: "ro"`);
            } else {
                console.log(`Document ${document.id} already has language: ${data.language}`);
            }
        });

        await Promise.all(updates);
        console.log('All documents processed.');
    } catch (error) {
        console.error('Error processing documents:', error);
    }
};


export default setReviewDefaultLanguage;